import * as React from "react";
import People from "src/components/general/People";
import { ICouncil } from "src/interfaces";
import DataMissing from "src/components/general/DataMissing";
import CouncilIdentityBadge, { ICouncilIdentityBadge } from "src/components/general/CouncilIdentity";


interface IProps {
  ordinal: number;
  council: ICouncil;
  year: string;
  meeples: number;
  residents: number;
}

export default class SingleCouncil extends React.PureComponent<
IProps, 
{},
ICouncilIdentityBadge
> {
  public render() {
    return (
      <div className={`flex flex-auto flex-wrap self-stretch w-full md:w-1/2 lg:w-1/4 pr-4 ${this.props.residents ? 'justify-between' : 'justify-center'}`}>

          <div className="hidden lg:block pl-10 person-yellow">
            <People 
              normal={ this.props.meeples + 1 }
            />
          </div>

          <div>
            <div className="flex flex-row items-center lg:pl-10">
              <CouncilIdentityBadge 
                name={ this.props.council.name }
                badge={ this.props.ordinal }
                modifier="justify-left"
              />
            </div>

            <div className="lg:hidden pl-10 lg:pl-0 person-yellow">
              <People 
                normal={ this.props.meeples + 1 }
              />
            </div>

            {this.props.residents ? (
              <h2 className="pb-10 items-center pl-10">
                {this.props.residents} <small>residents</small>
              </h2>
            ) : (
              <div className="pt-5 pb-10">
                <DataMissing align="left" />
              </div>
            )}
          </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/report/councilExpenditure/CouncilService/SingleCouncil.tsx